<div class="container-fluid">
    <mat-toolbar class="toolbar-bg-blue">
        <h2>Create Organization Leave</h2>
        <div class="forModalClose">
            <span (click)="cancel()">X</span>
        </div>

    </mat-toolbar>
    <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="isShowAlert">
        <b> Organization Leave created successfully.</b>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="orgLeaveForm" #myForm="ngForm" (ngSubmit)="orgLeaveFormSubmit()">

        <mat-form-field *ngIf="isShowOrganization">
            <mat-label>Organizations</mat-label>
            <mat-select formControlName="org_id">
                <mat-option *ngFor="let organization of organizations;" [value]="organization?.org_id">{{organization?.name}}</mat-option>
            </mat-select>
            <mat-error *ngIf="orgLeaveFormValidate?.org_id?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Year</mat-label>
            <input type="text" formControlName="leaves_for_year" [matDatepicker]="datepicker" (focus)="datepicker.open()" matInput>
            <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
            <mat-datepicker #datepicker (yearSelected)="chosenYearHandler($event,datepicker)" startView="multi-year">
            </mat-datepicker>
            <mat-error *ngIf="orgLeaveFormValidate?.leaves_for_year?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Leave Type</mat-label>
            <mat-select formControlName="leave_type">
                <mat-option *ngFor="let leaveType of leaveTypes;" [value]="leaveType?.id">
                    <span>{{leaveType?.leave_type}}</span>
                </mat-option>
            </mat-select>
            <mat-error *ngIf="orgLeaveFormValidate?.leave_type?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Leaves</mat-label>
            <input type="number" min="0" formControlName="leaves" matInput>
            <mat-error *ngIf="orgLeaveFormValidate?.leaves?.errors?.required">This field is required.</mat-error>
            <mat-error *ngIf="orgLeaveFormValidate?.leaves?.errors?.min">Please enter positive numbers.</mat-error>

        </mat-form-field>

        <div class="footer-block text-center">
            <div class="button-group">
                <button type="submit" mat-raised-button class="btn-int-blue">Create </button>
            </div>
        </div>
    </form>
</div>